export default __webpack_public_path__ + "static/media/InsideMuscles_10.084031ce.png";